import React from 'react';
import {
  ResourcesMegaMenuFeaturedWrapper,
  ResourcesMegaMenuFeaturedWrapperProps,
  ResourcesMegaMenuFeaturedContainerProps,
  ResourcesMegaMenuFeaturedContainer,
  ResourcesMegaMenuFeaturedEntries,
  ResourcesMegaMenuFeaturedEntry,
  FeaturedEntryText,
  FeaturedEntryLink,
} from './ResourcesMegaMenuFeatured.styles';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';
import { graphql, useStaticQuery } from 'gatsby';
import { IStaticContentfulImages } from 'src/types/contentful';
import { GatsbyImage } from 'gatsby-plugin-image';
import Heading from 'src/elements/typography/heading';
import IconsCallToActionArrow from 'src/images/IconsCallToActionArrow';

type ResourcesMegaMenuFeaturedProps = ResourcesMegaMenuFeaturedWrapperProps & ResourcesMegaMenuFeaturedContainerProps;

const ResourcesMegaMenuFeatured = ({
  noBackground = false,
  isFullWidth = false,
}: ResourcesMegaMenuFeaturedProps): JSX.Element => {
  const { masterclass, community } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      masterclass: contentfulAsset(contentful_id: { eq: "66ZGleRAnX1VBb6v23bB9g" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      community: contentfulAsset(contentful_id: { eq: "3PGnHm6FoAh8yFxU4EYAnJ" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  return (
    <ResourcesMegaMenuFeaturedWrapper noBackground={noBackground}>
      <ResourcesMegaMenuFeaturedContainer isFullWidth={isFullWidth}>
        <Paragraph
          standardSize='0.75'
          letterSpacing={1.5}
          text='FEATURED'
          align='left'
          weight={600}
          color={palette.darkSilver}
        />
        <ResourcesMegaMenuFeaturedEntries>
          <ResourcesMegaMenuFeaturedEntry>
            <GatsbyImage
              image={masterclass.gatsbyImageData}
              alt='Unlock free masterclass'
            />
            <FeaturedEntryText>
              <Heading
                standardSize='1.25'
                text={`Unlock our FREE Masterclass`}
                weight={700}
              />
              <Paragraph
                standardSize='0.75'
                text={`Learn about the 9 SIMPLE STEPS to creating a community so valuable it could generate $1M in revenue and 99% profit margins with AI.`}
                weight={400}
              />
            </FeaturedEntryText>
            <FeaturedEntryLink
              text='Unlock the FREE Masterclass'
              url='/peoplemagic'
              colorScheme='Black'
              colorSchemeVariant='tertiary'
              customBorderColor='transparent'
              standardSize='0.75'
              className='image-link'
              icon={
                <IconsCallToActionArrow
                  color='greyText'
                  width={14}
                />
              }
            />
          </ResourcesMegaMenuFeaturedEntry>
          <ResourcesMegaMenuFeaturedEntry>
            <GatsbyImage
              image={community.gatsbyImageData}
              alt='Join Mighty community'
            />
            <FeaturedEntryText>
              <Heading
                standardSize='1.25'
                text={`Join Mighty Community`}
                weight={700}
              />
              <Paragraph
                standardSize='0.75'
                text={`Learn the principles of Community Design™ (and see them in action) alongside thousands of creators and entrepreneurs. It's free to join!`}
                weight={400}
              />
            </FeaturedEntryText>
            <FeaturedEntryLink
              text='Join Now'
              url='https://community.mightynetworks.com/feed?utm_source=website&utm_medium=resources_menu&utm_campaign=mc_education'
              colorScheme='Black'
              colorSchemeVariant='tertiary'
              customBorderColor='transparent'
              standardSize='0.75'
              className='image-link'
              icon={
                <IconsCallToActionArrow
                  color='greyText'
                  width={14}
                />
              }
            />
          </ResourcesMegaMenuFeaturedEntry>
        </ResourcesMegaMenuFeaturedEntries>
      </ResourcesMegaMenuFeaturedContainer>
    </ResourcesMegaMenuFeaturedWrapper>
  );
};

export default ResourcesMegaMenuFeatured;
